import { db } from "common/config/Firebase"

const ticketDetailCollection = db.collection('ticketDetail')

const findTicketDetailByIdUseCase = async (id) => {
    const data = await ticketDetailCollection.doc(id).get()
    return data.data() || { data: [] }
}

export default findTicketDetailByIdUseCase